import { Button, FlexBox, ReviewStars, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { analytics } from 'segment_analytics'
import { formatRating } from 'components/review_pill/utils'
import { useActions } from 'hooks'
import { BookDetailReviewsMain } from './BookDetailReviewsMain'
import { BookDetailReviewsPreview } from './BookDetailReviewsPreview'

export const BookDetailReviews = ({
  book,
  mini,
}: {
  book: Book
  mini: boolean
}) => {
  const { colors, mediaQueries } = useTheme()
  const { openModal } = useActions()
  const reviewCount = book?.review_count || 0
  const zeroReviews = reviewCount === 0
  const buttonProps = {
    className: css`
      margin-top: 24px;
      width: 100%;
    `,
    custom: {
      backgroundColor: colors.uiGraphite,
      borderColor: colors.uiGraphite,
    },
  }

  const getTitle = () => {
    if (zeroReviews) return 'No Reviews'
    return `${reviewCount} Review${reviewCount > 1 ? 's' : ''}`
  }

  const header = (
    <FlexBox justifyContent="space-between" alignItems="center">
      <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
        {getTitle()}
      </Text>
      {zeroReviews ? null : (
        <FlexBox alignItems="center">
          <ReviewStars
            readOnly
            color={colors.uiGraphite}
            rating={book?.review_average || 0}
            size={16}
            spacing={2}
          />
          <Text
            className={css`
              margin-left: 4px;
            `}
            tag="span"
            type="header"
            sizing="XXS"
            color={colors.uiGraphite}
          >
            {formatRating(book?.review_average || 0)}
          </Text>
        </FlexBox>
      )}
    </FlexBox>
  )

  const renderButton = () => {
    if (zeroReviews) {
      return (
        <Button
          {...buttonProps}
          onClick={() => analytics.actions.appDownloadDeeplink()}
        >
          Review this book
        </Button>
      )
    }

    if (reviewCount < 5) return null

    return (
      <Button
        {...buttonProps}
        onClick={() =>
          openModal(
            <div
              className={css`
                margin: 0 auto;
                padding: 24px;
                max-width: 420px;
                width: 100%;
                max-height: 80vh;
                overflow-y: auto;
                @media only screen and (min-height: 800px) {
                  max-height: 700px;
                }
              `}
            >
              {header}
              <BookDetailReviewsMain book={book as Book} />
            </div>,
            cx(
              css`
                .modal {
                  ${mediaQueries.mobileL} {
                    min-width: 420px;
                  }
                }
              `,
              'm-card'
            )
          )
        }
      >
        See all Reviews
      </Button>
    )
  }

  return (
    <div>
      {header}
      {zeroReviews ? null : (
        <BookDetailReviewsPreview book={book} mini={mini} />
      )}
      {mini ? null : renderButton()}
    </div>
  )
}
